import { useNavigate } from "react-router-dom";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog"

export const MensajeAdvertenciaDialog = ({
    open,
    onClose,
    onAccept,
    onCancel,
    title = 'Advertencia',
    message,
    acceptText = 'Aceptar',
    cancelText = 'Cancelar',
    mustGoBack = true
}) => {
    const navigate = useNavigate();

    const handleCancel = () => {
        onCancel();
        if (mustGoBack) {
            navigate(-1);
        }
    };

    return (
        <CustomDialog
            open={open}
            onClose={handleCancel}
            onAccept={onAccept}
            onCancel={handleCancel}
            dialogTitle={title}
            children={message}
            acceptText={acceptText}
            cancelText={cancelText}
            onBackdropClick={() => { }}
        />
    )
}